import { TFunction } from 'i18next';
import { getOnpremHostname } from 'omni-package-react-core';
import Configuration from '../../../utils/Configuration';
export interface getSignInConfigurationResult {
  i18n: {};
  helpLinks: {};
  features: {};
  mobileDeviceMode: Boolean;
  defaultCountryCode: String;
  useClassicEngine: Boolean;
  baseUrl: String;
}

export function getSignInConfiguration(t: TFunction, mobileDeviceMode: Boolean, disableSignUp?: Boolean): getSignInConfigurationResult {
  const config = Configuration.Current();
  const onPremHostName = getOnpremHostname();
  const oieFR = {
    'oie.webauthn.label': 'Authentifiant biométrique',
    'oie.remember': 'Ne plus me vérifier sur cet appareil pendant 30 jours',
    'mfa.challenge.verify': 'Suivant',
    'oie.enroll.google_authenticator.scanBarcode.description': 'Lancez Google Authenticator, onglet « + », puis sélectionnez « Scanner le code-barres ».',
    'oie.enroll.switch.authenticator': 'Revenir à la liste des authentifiants',
    'oie.google_authenticator.authenticator.description': 'Saisissez un code temporaire généré à partir de l’application Google Authenticator',
    'oie.select.authenticators.enroll.subtitle': 'Les méthodes de sécurité vous aident à protéger votre compte en assurant que vous seul pouvez y accéder.',
    'oie.webauthn.description': 'Connectez-vous via clé de sécurité ou authentifiant biométrique',
    'oie.enroll.okta_verify.qrcode.step2': 'Ouvrez l\'application et suivez les instructions pour ajouter votre compte.',
    'oie.enroll.okta_verify.qrcode.step3': 'Acceptez l\'invitation vous demandant de scanner le code QR ci-dessous :',
    'oie.enroll.okta_verify.select.channel.email.label': 'Recevoir un lien de configuration par courriel',
    'oie.email.label': 'Courriel',
    'oie.phone.verify.sms.codeSentText': 'Un code a été envoyé à',
    'oie.enroll.okta_verify.channel.email.label': 'Courriel',
    'oie.enroll.okta_verify.channel.email.description': 'Vous devez pouvoir accéder au courriel sur votre appareil mobile.',
    'mfa.calling': 'Appel en cours',
    'mfa.redial': 'Rappeler',
    'phone.extention.label': 'Poste',
    'mfa.phoneNumber.ext.placeholder': 'Poste',
    'oie.enroll.google_authenticator.manualSetupInstructions': 'Pour installer manuellement, saisissez le nom d’utilisateur de votre compte puis entrez ce qui suit dans le champ Clé secrète.',
    'oie.verify.webauthn.instructions': 'Vous serez invité à utiliser une clé de sécurité ou un authentifiant biométrique (Windows Hello, Touch ID, etc.). Suivez les instructions pour terminer la vérification.',
    'oie.verify.webauthn.cant.verify.biometric.authenticator.description1': 'Les authentifiants biométriques (empreintes digitales, reconnaissance faciale, code confidentiel) fonctionneront uniquement sur le périphérique sur lequel ils ont été configurés.',
    'oie.verify.webauthn.cant.verify.biometric.authenticator.description2': 'Si possible, veuillez configurer une autre méthode de sécurité sur le périphérique que vous avez utilisé pour configurer votre authentifiant biométrique.',
    'oie.verify.webauthn.cant.verify.biometric.authenticator.title': 'Essayez-vous d\'utiliser un authentifiant biométrique?',
    'oie.enroll.okta_verify.email.info': 'Nous avons envoyé un courriel contenant un lien de configuration pour Okta Verify à <span class="strong">{0}</span>. Pour continuer, ouvrez ce lien sur votre appareil mobile.',
    'oie.enroll.okta_verify.email.notReceived': 'Vous n\'avez pas reçu de courriel ? Consultez vos courriers indésirables ou <a href="#" class="resend-link">renvoyez le courriel</a>',
    'primaryauth.username.placeholder': 'Nom d\'utilisateur',
    'errors.E0000004': 'Le nom d\'utilisateur ou le mot de passe est incorrect.',
    'errors.E0000069': 'Le nom d\'utilisateur ou le mot de passe est incorrect.',
    'errors.E0000047': 'Le nom d\'utilisateur ou le mot de passe est incorrect.',
    remember: 'Mémoriser le nom d\'utilisateur',
    'primaryauth.submit': 'Me connecter',
    'enroll.choices.setup': 'Choisir',
    'enroll.choices.submit.configure': 'Choisir',
    'enroll.choices.description.generic': 'Vous devez activer l\'authentification multifacteur (MFA) afin d\'ajouter une couche de sécurité supplémentaire lors de la connexion à votre compte.',
    'enroll.totp.setupApp': 'Lancez {0} sur votre appareil mobile et sélectionnez « Ajouter un compte ». Numérisez le code QR pour continuer.',
    'enroll.totp.cannotScan': 'Impossible de numériser ?',
    'enroll.totp.cannotScanBarcode': 'Vous n\'arrivez pas à numériser le code QR ?',
    'factor.totpSoft.description': 'Utiliser l\'application mobile pour vous authentifier.',
    'factor.push.description': 'Utiliser l\'application mobile Okta Verify pour vous authentifier.',
    'factor.sms.description': 'Vérification via un code envoyé par texto sur votre téléphone.',
    'factor.sms.time.warning': 'Vous n\'avez pas reçu  de SMS? Pour réessayer, cliquez sur <$1>Renvoyez le code</$1>.',
    signout: 'Précédent',
    'mfa.backToFactors': 'Précédent',
    'password.expired.custom.submit': '{0}r',
    'password.expired.custom.subtitle': 'Par mesure de sécurité, vous devrez définir un nouveau mot de passe à l\'étape suivante.',
    'error.username.required': 'Champ obligatoire',
    'error.password.required': 'Champ obligatoire',
    forgotpassword: 'Mot de passe oublié?',
    loginErrorCounter: 'Veuillez nous joindre pour obtenir de l’aide.',
    'registration.title': 'Créer un compte',
    'forgotUsername.title': 'Nom d\'utilisateur oublié?',
    'cancel.title': 'Retour à la page de connexion',
    'rememberDevice.timebased': 'Ne plus me vérifier sur cet appareil pendant {0}',
  };
  const oieEN = {
    'oie.webauthn.label': 'Biometric Authenticator',
    'oie.remember': 'Do not challenge me on this device for the next 30 days',
    'mfa.challenge.verify': 'Next',
    'oie.google_authenticator.authenticator.description': 'Enter a temporary code generated from the Google Authenticator app',
    'oie.enroll.switch.authenticator': 'Return to authenticators list',
    'oie.enroll.google_authenticator.manualSetupInstructions': 'To set up manually, enter your username and then input the following in the Secret Key field.',
    'oie.enroll.okta_verify.qrcode.step2': 'Open the app and follow the instructions to add your account.',
    'mfa.challenge.enterCode.placeholder': 'Enter Code',
    'mfa.challenge.enterCode.tooltip': 'Enter Code',
    'oie.phone.carrier.charges': 'Carrier messaging charges may apply.',
    'oie.phone.invalid': 'Invalid phone number.',
    'oie.verify.google_authenticator.otp.description': 'Enter the temporary code generated in your Google Authenticator app.',
    'primaryauth.username.placeholder': 'Username',
    'errors.E0000004': 'The username or password is incorrect.',
    'errors.E0000069': 'The username or password is incorrect.',
    'errors.E0000047': 'The username or password is incorrect.',
    remember: 'Remember the username',
    'primaryauth.submit': 'Sign In',
    'enroll.choices.setup': 'Choose',
    'enroll.choices.submit.configure': 'Choose',
    'enroll.choices.description.generic': 'You must enable Multi-Factor Authentication (MFA) to add an additional layer of security when logging into your account.',
    'factor.totpSoft.description': 'Use the mobile app to sign in.',
    'factor.push.description': 'Use the Okta Verify mobile app to authenticate yourself.',
    'factor.sms.description': 'Enter a single-use code sent to your mobile phone.',
    signout: 'Back',
    'mfa.backToFactors': 'Back',
    'password.expired.custom.submit': '{0}',
    'password.expired.custom.subtitle': 'For security purposes, you must reset your password at the next step.',
    'error.username.required': 'Mandatory field',
    'error.password.required': 'Mandatory field',
    forgotpassword: 'Forgot password?',
    loginErrorCounter: 'Please contact us for assistance.',
    'registration.title': 'Create an account',
    'forgotUsername.title': 'Forgot username?',
    'cancel.title': 'Back to sign in',
    'rememberDevice.timebased': 'Do not challenge me on this device for the next {0}',
  };

  const signInConfigurationResult: getSignInConfigurationResult = {
    i18n: {
      fr: oieFR,
      en: oieEN,
    },

    helpLinks: {
      forgotPassword: `${onPremHostName}${config.forgetPasswordPath}`,
    },
    features: {
      customExpiredPassword: true,
      multiOptionalFactorEnroll: true,
      showPasswordToggleOnSignInPage: true,
      selfServiceUnlock: false,
      webauthn: true,
      scrollOnError: false,
      rememberMe: true,
      rememberMyUsernameOnOIE: true,
      showKeepMeSignedIn: true,
      router: config.featuresRouter,
      registration: !disableSignUp,
      idpDiscovery: config.useIdPDiscovery,
    },
    mobileDeviceMode,
    defaultCountryCode: 'CA',
    useClassicEngine: config.useClassicEngine,
    baseUrl: config.idpTenantUrl,
    /*
    {
        "emailRecovery": true,
        "restrictRedirectToForeground": true,
        "deviceFingerprinting": true,
        "showIdentifier": true,
        "consent": true,
        "useDeviceFingerprintForSecurityImage": false,
        "customExpiredPassword": true,
        "router": true,
        "securityImage": true,
        "autoPush": true,
        "smsRecovery": false,
        "idpDiscovery": false,
        "selfServiceUnlock": false,
        "webauthn": true,
        "passwordlessAuth": true,
        "showPasswordRequirementsAsHtmlList": true,
        "rememberMe": true,
        "callRecovery": false,
        "multiOptionalFactorEnroll": true
    }
    */
  };
  return signInConfigurationResult;
}
